import { Link } from '@tanstack/react-router'
import { FileText } from 'lucide-react'
import type { ReactElement } from 'react'

import { Button } from '@/components/ui/button'

import { EmptyState } from './empty-state'

/** Rota inexistente. Também é um estado — e também não pode ser tela branca. */
export function NotFoundState(): ReactElement {
  return (
    <div className="mx-auto w-full max-w-2xl p-6">
      <EmptyState
        icone={FileText}
        titulo="Página não encontrada"
        descricao="O endereço que você abriu não existe no painel. Talvez o link esteja desatualizado."
        acao={
          <Button asChild variant="secondary">
            <Link to="/">Voltar para o início</Link>
          </Button>
        }
      />
    </div>
  )
}
